import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './pages/home/home';
import About from './pages/about';
import Header from './components/header/header';
import Footer from './components/footer/footer'
import Cenik from "./pages/cenik";
import Privacy from "./pages/privacy";
import Stripe from "./components/header/stripe";
import ScrollToTop from "./ScrollToTop";
import MobileCallButton from "./components/ui/MobileCallButton";


const App = () => {
    return (
        <Router>
            <ScrollToTop />
            <Stripe/>
            <Header/>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/cenik" element={<Cenik/>}/>
                <Route path="/o-mne" element={<About/>}/>
                <Route path="/zasady-ochrany-osobnich-udaju" element={<Privacy/>}/>
            </Routes>
            <Footer/>
            <MobileCallButton/>
        </Router>
    );
};

export default App;
